import type { ActionNode } from "@repo/shared/workflow";

export type RunnerProps = {
  taskId: string;
  runId: string;
  actionNode: ActionNode;
};

import emailSvg from "@/../public/email.svg";
import exportSvg from "@/../public/export.svg";
import restSVG from "@/../public/rest.svg";
import rpaSvg from "@/../public/rpa.svg";
import type { ActionSubtype } from "@repo/shared/workflow";

export const ACTIONS_CONFIG: Record<
  ActionSubtype,
  {
    icon: string;
    label: string;
    hide?: boolean;
  }
> = {
  rest: {
    icon: restSVG,
    label: "REST",
    hide: true,
  },
  rpa: {
    icon: rpaSvg,
    label: "RPA",
  },
  export: {
    icon: exportSvg,
    label: "Export",
  },
  "send-email": {
    icon: emailSvg,
    label: "Email",
  },
};
